/*jshint esversion:6 */
import React from "react";
import DisputesTable from "./disputesTable";
import DisputesFilter from "./disputesFilter";
import DisputeModal from "./modal/disputeModal";
import Divider from "../../common/divider";
import PageTitle from "../../common/pageTitle";
import Messages from "../../../configurations/messages";
import Breadcrumbs from "react-breadcrumbs";
import Toaster from "toastr";
import { connect } from "react-redux";
import { Permissioned } from "react-permissions";
import DisputesAPI from "../../../api/DisputesApi";
import Util from "../../../util/util";
import Constants from "../../../configurations/constants";
import Permissions from "../../../configurations/permissions";
import ReportsApi from "../../../api/ReportsApi";
import GenerateForm from "../../reports/GenerateForm";

class DisputesPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      tableData: [],
      totalCount: 0,
      selectedDispute: null,
      loading: false,
      showTable: false,
      pages: 0,
      pageSize: Constants.DEFAULT_TABLE_PAGE_SIZE,
      pageNum: 0, //Zero based index
      filterParams: null,
      stop_pinging: false,
      generating: [],
      reportsProgress: []
    };
    this.onSearchHandler = this.onSearchHandler.bind(this);
    this.onDisputeRowClick = this.onDisputeRowClick.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.onTableChange = this.onTableChange.bind(this);
    this.paginateid = this.paginateid.bind(this);
    this.generateReport = this.generateReport.bind(this);
    this.addToProgressList = this.addToProgressList.bind(this);
    this.getReportStatus = this.getReportStatus.bind(this);
    this.fetchStatus = this.fetchStatus.bind(this);
    this.onDownloadClick = this.onDownloadClick.bind(this);
    this.onRetryClick = this.onRetryClick.bind(this);
    this.clearDownloads = this.clearDownloads.bind(this);
    this.deleteDownload = this.deleteDownload.bind(this);
  }

  deleteDownload(index) {
    const reportsProgress = [...this.state.reportsProgress];
    reportsProgress.splice(index, 1);
    if(reportsProgress.length) {
      this.setState({ reportsProgress });
    } else {
      this.clearDownloads();
    }
  }

  clearDownloads() {
    this.setState({
      showTable: false,
      reportsProgress: []
    });
  }

  onRetryClick(row) {
    const { id } = row;
    ReportsApi.retryReportGeneration("disputes", id)
      .then(response => {
        Toaster.success("Report generation resent");
      })
      .catch(error => {
        Util.errorMessageToast(Toaster, error.data, [` ${error.description}`]);
      });
  }

  onDownloadClick(filename) {
    ReportsApi.downloadReport(filename)
      .then(response => {
        window.open(response.config.url, "_blank");
      })
      .catch(error => {
        Util.errorMessageToast(Toaster, error.data, [` ${error.description}`]);
      });
  }

  getReportStatus(report) {
    if(this.state.showTable) {
      this.fetchStatus(report.id)
    }
  }

  fetchStatus(id) {
    const reports = this.state.reportsProgress;
    ReportsApi.getReport(null, id)
    .then(response => {
      if(reports && reports.length > 0) {
        const objIndex = reports.findIndex(report => report.id === id);
        const updatedObj = {
          ...reports[objIndex],
          ...response.data
        };
        const reportsProgress = [
          ...reports.slice(0, objIndex),
          updatedObj,
          ...reports.slice(objIndex + 1)
        ];
        this.setState({
          reportsProgress
        });
      }
    })
    .catch(error => {
      Util.errorMessageToast(Toaster, error.data, [
        "Error in fetching report status"
      ]);
    });
  }

  generateReport(reportType) {
    let generating = this.state.generating.slice();
    generating[reportType] = true;
    this.setState({ generating });
    if (this.state.filterParams) {
      let params = Util.clone(this.state.filterParams);
      params.reportType = reportType;
      const reportCategory = "disputes";
      ReportsApi.generateReport(params, reportCategory)
        .then(response => {
          Toaster.success("Dispute report request successful!");
          this.setState({ generating: [], showTable: true });
          response && this.addToProgressList(response.data);
        })
        .catch(error => {
          Util.errorMessageToast(Toaster, error.data, [
            ` ${Messages.ERROR_GENERATING_REPORTS}`
          ]);
          this.setState({ generating: [], showTable: true });
        });
    }
  }

  paginateid(index) {
    const offset = parseInt(this.state.pageNum, 0);
    //const idx = parseInt(index, 0);
    const pagesize = parseInt(this.state.pageSize, 0);
    const result =
      offset * pagesize + index + Constants.PAGINATION_OFFSET_INDEX;
    return result.toString();
  }
  componentDidMount() {
    //Load data on mount
    this.onSearchHandler({ pageSize: this.state.pageSize });
  }
  onSearchHandler(params, resetPageNumber) {
    //Reset states
    let stateUpdate = { loading: true, tableData: [] };
    if (resetPageNumber) {
      stateUpdate.pageNum = 0;
      params.pageNum = 1;
    }
    this.setState(stateUpdate);
    params.pageSize = params.pageSize || this.state.pageSize;
    params.pageNum = params.pageNum || this.state.pageNum + 1;

    DisputesAPI.findDisputes(params)
      .then(response => {
        let data = response.data.content;
        data = data.map(d => {
          return {
            ...d,
            transactionDate: Util.toUserLocalTime(d.transactionDate),
            createdOn: Util.toUserLocalTime(d.createdOn),
            statusStartDate: Util.toUserLocalTime(d.statusStartDate),
            statusScheduledEndDate: Util.toUserLocalTime(
              d.statusScheduledEndDate
            )
          };
        });
        let totalCount = response.data.count;
        let pages = totalCount
          ? Math.ceil(
              totalCount /
                (params.pageSize || Constants.DEFAULT_TABLE_PAGE_SIZE)
            )
          : 0;
        if (data.length === 0) Toaster.warning("No records found.", "Disputes");

        this.setState({
          tableData: data,
          loading: false,
          filterParams: params,
          totalCount: totalCount,
          pages: pages
        });
      })
      .catch(error => {
        console.log(error);
        Util.errorMessageToast(Toaster, error.data, [
          `${Messages.ERROR_DISPUTES_SEARCH}`,
          `${Messages.ERROR_DISPUTES_SEARCH_TITLE}`
        ]);
        this.setState({ loading: false });
      });
  }
  onDisputeRowClick(index) {
    this.setState({ selectedDispute: this.state.tableData[index] });
  }
  handleCloseModal(event, reloadDataFlag) {
    this.setState({ selectedDispute: null });
    if (reloadDataFlag) {
      this.onSearchHandler(this.state.filterParams);
    }
  }

  onTableChange(state, instance) {
    let pageSize = instance.state.pageSize;
    let pageNum = instance.state.page; //table page  - Zero based index
    this.setState({ pageSize: pageSize, pageNum: pageNum });
    if (this.state.filterParams) {
      let params = Util.clone(this.state.filterParams);
      params.pageSize = pageSize;
      params.pageNum = pageNum + 1;

      this.onSearchHandler(params);
    }
  }

  addToProgressList(reportObject) {
    this.setState({
      reportsProgress: [...this.state.reportsProgress, reportObject]
    });
  }

  render() {
    const { tableData, generating, filterParams, reportsProgress, stop_pinging, showTable } = this.state;
    let isFiltered;
    if (filterParams) {
      const { pageSize, pageNum, ...hasFilter } = filterParams;
      isFiltered =
        Object.keys(hasFilter).length !== 0 && hasFilter.constructor === Object;
    }

    const showGenerateForm = isFiltered && tableData && tableData.length;

    return (
      <div>
        <div id="page-breadcrumb" className="breadcrumb-container">
          <Breadcrumbs
            separator={Constants.BREADCRUMB_SEPARATOR}
            routes={this.props.routes}
            params={this.props.params}
          />
        </div>
        <PageTitle title="Disputes" />
        <DisputesFilter onSearchHandler={this.onSearchHandler} />
        <Divider />
        <GenerateForm
          data={tableData}
          generating={generating}
          progressList={reportsProgress}
          showForm={showGenerateForm}
          generate={this.generateReport}
          getReportStatus={this.getReportStatus}
          deleteDownload={this.deleteDownload}
          retry={this.onRetryClick}
          showTable={showTable}
          clearDownloads={this.clearDownloads}
          download={this.onDownloadClick}
          stop_pinging={stop_pinging}
        />

        <DisputesTable
          onRowClick={this.onDisputeRowClick}
          tableData={this.state.tableData}
          loading={this.state.loading}
          onTableChange={this.onTableChange}
          page={this.state.pageNum}
          pages={this.state.pages}
          defaultPageSize={Constants.DEFAULT_TABLE_PAGE_SIZE}
          paginatedCallBack={this.paginateid}
        />
        {this.state.selectedDispute && (
          <DisputeModal
            onRequestClose={this.handleCloseModal}
            isOpen={this.state.selectedDispute != null}
            dispute={this.state.selectedDispute}
          />
        )}
      </div>
    );
  }
}

export default connect(Util.defaultMapStateToProps)(
  Permissioned(DisputesPage, [Permissions.VIEW_DISPUTE])
);



// WEBPACK FOOTER //
// ./src/components/disputeMgmt/disputes/disputesPage.js